export enum PropertyDisplayType {
  SINGLE = 'SINGLE',
  MULTI = 'MULTI',
  SECRET_WARNING = 'SECRET'
}
